require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./archizoom-1-8-1-0.json") })
        }
      }, "path---archizoom-1-8-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---archizoom-1-8-1-0!./.cache/json/archizoom-1-8-1-0.json
// module id = 332
// module chunks = 231608221292675